'use strict';

import type { AgencyAgencyDownline } from '../../Entities/Agency/AgencyAgencyDownline';
import { EntityCollection } from '../EntityCollection';

export class AgencyAgencyDownlineCollection extends EntityCollection<AgencyAgencyDownline> {}
